/* eslint-disable import/no-default-export */
import { fields as creditCardFields, FIELDS } from './constants';
import messages from './messages';
import { rules } from './validation';

function isExpiryField(field) {
    return field === FIELDS.FIELD_EXPIRY_MONTH || field === FIELDS.FIELD_EXPIRY_YEAR;
}

function getErrorMessage(field, creditCard, options) {
    const isEmpty = !creditCard[field];
    let skipValidationRules = true;

    if (isExpiryField(field)) {
        const emptyExpiryFields = Object.keys(creditCard).filter(
            fieldName => isExpiryField(fieldName) && !creditCard[fieldName]
        );
        // Apply validation rules for expiry fields when none of it or both has values
        skipValidationRules = emptyExpiryFields.length === 1;
    }

    const validationRules = rules[field] ? rules[field](creditCard, options) : [];
    const failedRules =
        isEmpty && skipValidationRules
            ? []
            : validationRules.filter(function (rule) {
                  return !rule.isValid;
              });
    return failedRules.length
        ? failedRules[0].message
        : isEmpty && (messages[field] || messages.required);
}

/**
 * Return an Object with two properties: errors and isValid:
 * errors (Object): field name and error message (Example -> { cardHolderName: "Required field", creditCardNumber: "Please enter a valid credit card number" })
 * isValid (Boolean): check if the credit card has any errors
 * @param creditCard (Object): field names and values
 * @param options (Object): can except one of the following keys:
 * fields (Array) - custom list of fields to validate
 * maskedCardNumber (String)
 */
function validate(_creditCard, _options) {
    const creditCard = _creditCard || {};
    const options = _options || {};
    const errors = (options.fields || creditCardFields).reduce(function (_errors, field) {
        const message = getErrorMessage(field, creditCard, options);
        if (message) {
            _errors[field] = message;
        }
        return _errors;
    }, {});

    return {
        errors: errors,
        isValid: !Object.keys(errors).length,
    };
}

export { getExpiryYear, getExpiryMonth } from './helpers/expiry';
export default validate;
